import fetchToCurl from 'fetch-to-curl';

import type { IErrorResult, IfetchOptions, IHTTPErrors } from './types';

const ERRORS: IHTTPErrors = {
  404: 'Not Found',
  500: 'Server Error',
};
const RETRY_CODES = [408, 500, 502, 503, 504, 522, 524];
const TBX_ENV = window.__TBX_ENV__;

function getURLwithBuildParam(url: string) {
  const BUILD_TIMESTAMP = process.env.REACT_APP_BUILDTIME || TBX_ENV.REACT_APP_BUILDTIME;
  const appendString = /[?&]/.test(url)
    ? `&b=${BUILD_TIMESTAMP}`
    : `?b=${BUILD_TIMESTAMP}`;
  return url + appendString;
}

/**
 * Data downloading using pure JS fetch
 *
 * @param  {*}       url     URL to fetch data
 * @param  {*}       options Request options
 * @return {Promise}         Fetch promise
 */
export function fetchData(
  url: string,
  options: IfetchOptions = {},
  retries: number = 0,
  backoff: number = 300
) {
  const completeURL = getURLwithBuildParam(url);
  let finalOptions = {
    ...options,
  };

  finalOptions.headers = {
    ...finalOptions.headers,
    //'ngrok-skip-browser-warning': 1,
  };

  const fetchRequest = new Request(completeURL, finalOptions);
  console.debug(fetchToCurl(completeURL, finalOptions));

  return fetch(fetchRequest)
    .then(async (response) => {
      if (!response.ok) {
        if (retries > 0 && RETRY_CODES.includes(response.status)) {
          setTimeout(() => {
            return fetchData(url, options, retries - 1, backoff * 2);
          }, backoff);
        }
        let errorResult: IErrorResult = {};
        const errorDefaultMessage =
          ERRORS[response.status] || 'Unknown server error!';

        errorResult.statusCode = response.status;

        errorResult = await response.json();

        if (!errorResult || Object.keys(errorResult).length === 0) {
          errorResult = errorResult || {};
          errorResult.error = errorDefaultMessage;
        }

        return { error: errorResult };
      }

      if (response.redirected) {
        return response;
      }

      const cType = response.headers.get('content-type');
      switch (true) {
        case cType?.includes('application/json'):
          return response.json().then((result) => result);
        case cType?.includes('application/octet-stream'):
          return response.blob().then((result) => result);
        default:
          return response.text().then((result) => result);
      }
    })
    .catch((error) => {
      console.error(
        '[netUtils/fetch] RESPONSE NOOK >>>',
        JSON.stringify(error)
      );
      return error;
    });
}
